
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import InspirationApi from "../../Api/inspirationApi"
import { setMessage } from "./message"
import EventBus from "../../utils/EventBus"


export const getInspiration = createAsyncThunk("inspiration/getInspiration", async (page, thunkAPI) => {
  try {
    const response = await InspirationApi.getInspiration(page)
    
    // console.log("res",response.data.message)
    return response.data
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message))
    return thunkAPI.rejectWithValue(message)
  }
})

export const addInspiration = createAsyncThunk(
  "inspiration/addInspiration",
  async (formData, thunkAPI) => {
    try {
      const response = await InspirationApi.addInspiration(formData);
      return response.data;
    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        EventBus.dispatch("logout");
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const confirmInspiration = createAsyncThunk("/add", async (formData, thunkAPI) => {
  try {
    const response = await InspirationApi.confirmInspiration(formData);
    return response.data;
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message);
  }
});


const InspirationSlice = createSlice({
  name: "inspiration",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInspiration.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.loading = false
      })
      .addCase(getInspiration.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      .addCase(addInspiration.fulfilled, (state, action) => {
        state.loading = false;
        state.data.push(action.payload.data); 
      })
      .addCase(addInspiration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
    },
  });
  
  const { reducer } = InspirationSlice
  export default reducer